export const formatExecutivePayload = (endPoint, payload) => {
  let url = `${endPoint}?sort=${payload?.sort ? payload?.sort : "id,asc"}&page=${payload?.page ? payload?.page : 0}&size=${payload?.size ? payload?.size : 10}`;
  if (payload?.Countries) {
    url = `${url}&country.in=${payload?.Countries}`;
  }
  if (payload?.States) {
    url = `${url}&state.in=${payload?.States}`;
  }
  if (payload?.Cities) {
    url = `${url}&city.in=${payload?.Cities}`;
  }
  if (payload?.Industry) {
    url = `${url}&industryId.in=${payload?.Industry}`;
  }
  if (payload?.["Company Type"]) {
    url = `${url}&categoryId.in=${payload?.["Company Type"]}`;
  }
  if (payload?.["Employee Count"]) {
    url = `${url}&rangeId.in=${payload?.["Employee Count"]}`;
  }
  if (payload?.["Revenue Range"]) {
    url = `${url}&revenueId.in=${payload?.["Revenue Range"]}`;
  }
  if (payload?.["Executive Function"]) {
    url = `${url}&exfunction.in=${payload?.["Executive Function"]}`;
  }
  if (payload?.["Executive Level"]) {
    url = `${url}&exlevel.in=${payload?.["Executive Level"]}`;
  }
  if (payload?.searchKeyword) {
    url = `${url}&title.contains=${payload?.searchKeyword}`;
  }
  if (payload?.Name) {
    url = `${url}&fullname.contains=${payload?.Name}`;
  }
  if (payload?.Tags) {
    url = `${url}&tags=${payload?.Tags}`;
  }
  if (payload?.["id.in"]) {
    url = `${url}&id.in=${payload?.["id.in"]}`;
  }
  return url;
};
